import layoutTypes from './layout.types';

export const setSideMenuCollapse = (status) => ({
  type: layoutTypes.SET_SIDE_MENU_COLLAPSE,
  payload: status,
});

export const setSecondMenuCollapsed = (status) => ({
  type: layoutTypes.SET_SECOND_MENU_COLLAPSE,
  payload: status,
});

export const setSecondMenuKey = (k) => ({
  type: layoutTypes.SET_SECOND_MENU_KEY,
  payload: k,
});
